import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Tag } from "lucide-react";
import { POSTS } from "../blog/posts";
import { Seo } from "../components/Seo";
import { BRAND } from "../brand";

const Blog = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "ooloo Blog — Kitchen Help & Recipes Lucknow",
    url: `${BRAND.siteUrl}/blog`,
    publisher: {
      "@type": "Organization",
      name: "ooloo",
      url: BRAND.siteUrl,
    },
    blogPost: POSTS.map((p) => ({
      "@type": "BlogPosting",
      headline: p.title,
      description: p.description,
      url: `${BRAND.siteUrl}/blog/${p.slug}`,
      datePublished: p.date,
    })),
  };

  return (
    <main data-testid="blog-page" className="bg-[#f7f5f2]">
      <Seo
        title="Kitchen Help, Recipes & Lucknow Living"
        description="Practical articles from ooloo — kitchen helper costs in Lucknow, quick North Indian dinners, festival cooking and hygiene SOPs."
        path="/blog"
        jsonLd={jsonLd}
      />

      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-12">
        <p className="eyebrow rise">ooloo journal</p>
        <h1 className="font-display mt-5 text-5xl md:text-7xl font-black tracking-tighter leading-[0.95] max-w-4xl rise rise-1">
          Stories from
          <span className="italic font-serif font-light text-[#c45b3e]"> Lucknow kitchens</span>.
        </h1>
        <p className="mt-6 max-w-2xl text-lg text-[#5c5a56] leading-relaxed rise rise-2">
          Honest takes on home cooking, pricing, festivals and the small habits
          that make a kitchen run beautifully.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
        <div className="grid md:grid-cols-12 gap-5">
          {POSTS.map((p, i) => {
            const isFeatured = i === 0;
            return (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className={`bento-card overflow-hidden p-0 group ${
                  isFeatured ? "md:col-span-12 md:flex" : "md:col-span-6 lg:col-span-4"
                }`}
              >
                <div
                  className={`relative overflow-hidden ${
                    isFeatured ? "md:w-1/2 md:h-auto h-[280px]" : "h-[220px]"
                  }`}
                >
                  <img
                    src={p.image}
                    alt={p.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                </div>
                <div className={`p-7 md:p-9 flex flex-col ${isFeatured ? "md:w-1/2" : ""}`}>
                  <div className="flex items-center gap-3 text-xs font-bold tracking-widest uppercase text-[#5c5a56]">
                    <span className="inline-flex items-center gap-1.5">
                      <Tag size={12} /> {p.category}
                    </span>
                    <span className="w-1 h-1 rounded-full bg-[#5c5a56]" />
                    <span className="inline-flex items-center gap-1.5">
                      <Clock size={12} /> {p.readMinutes} min
                    </span>
                  </div>
                  <h2
                    className={`mt-5 font-display font-extrabold tracking-tight leading-[1.05] text-[#0a0a0a] ${
                      isFeatured ? "text-3xl md:text-4xl" : "text-xl md:text-2xl"
                    }`}
                  >
                    {p.title}
                  </h2>
                  <p className="mt-3 text-[#5c5a56] leading-relaxed text-sm md:text-base">
                    {p.excerpt}
                  </p>
                  <span className="mt-6 inline-flex items-center gap-2 text-[#0a0a0a] font-bold link-underline self-start">
                    Read article <ArrowUpRight size={16} />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default Blog;
